// ============================================================
// 三端共用的常量路由（不参与权限校验）
// /login、/404、/403、/redirect/:path、404 fallback
// ============================================================
import type { RouteRecordRaw } from "vue-router";

declare module "vue-router" {
    interface RouteMeta {
        title?: string;
        icon?: string;
        iconDefault?: string;
        iconActive?: string;
        hidden?: boolean;
        hideInMenu?: boolean;
        affix?: boolean;
        /** 1=菜单 3=分组 */
        menuType?: number;
        /** 仅静态菜单兜底；动态树用 menuType=3 */
        groupName?: string;
        roles?: string[];
        noPin?: boolean;
        noCache?: boolean;
        keepAliveName?: string;
        singletonTagPath?: string;
        singletonNavConfirm?: boolean;
        singletonIdentity?: string;
        permissionCode?: string;
    }
}

/**
 * 常量路由 —— 每个端拿到自己的 loginPage 注入即可
 * loginPage 由各端 apps/<target>/views/login.vue 提供（壳是 shared/views/login）
 */
export function buildConstantRoutes(opts: { loginPage: () => Promise<unknown> }): RouteRecordRaw[] {
    return [
        {
            /** dev 多入口 html 路径兼容：/html/customer.html → /，再由鉴权重定向到登录页 */
            path: "/html/:entry",
            redirect: "/",
            meta: { hidden: true },
        },
        {
            path: "/login",
            name: "Login",
            component: opts.loginPage as never,
            meta: { title: "登录", hidden: true },
        },
        {
            path: "/redirect/:path(.*)",
            name: "Redirect",
            component: () => import("@shared/views/redirect/index.vue"),
            meta: { hidden: true },
        },
        {
            path: "/404",
            name: "NotFound",
            component: () => import("@shared/views/error/404.vue"),
            meta: { title: "页面不存在", hidden: true },
        },
        {
            path: "/403",
            name: "Forbidden",
            component: () => import("@shared/views/error/403.vue"),
            meta: { title: "无访问权限", hidden: true },
        },
    ];
}

/**
 * 兜底路由 —— 必须在动态路由注入完成后再 addRoute，否则会把真实路径吃成 404
 */
export const fallbackRoute: RouteRecordRaw = {
    path: "/:pathMatch(.*)*",
    name: "FallbackNotFound",
    redirect: "/404",
    meta: { hidden: true },
};
